<!-- Main Page Start -->
<div class="content-wrapper table-full-bx stepBox">
    <div class="stepper positionStatic" *ngIf="isStepper == 1">
        <!-- progress -->

        <div class="progress">
            <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:25%" aria-valuenow="25"
                aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <app-step-one [filledData]="filledData" [isAdd]="isAdd" (valueChange)='catchFile($event)'
            (changeDetected)="onChangeDetected($event)"></app-step-one>
    </div>
    <!--main div end   -->
    <div class="stepper positionStatic" *ngIf="isStepper == 2">
        <div class="progress">
            <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:45%" aria-valuenow="45"
                aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <!-- progress -->
        <app-step-two [filledData]="filledData" [isAdd]="isAdd" (valueChange)='catchFile($event)'
            (stepperChange)="stepChanged($event)" (changeDetected)="onChangeDetected($event)"></app-step-two>
    </div>
    <div class="stepper positionStatic" *ngIf="isStepper == 3">
        <div class="progress">
            <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:60%" aria-valuenow="60"
                aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <!-- End -->
        <app-step-three [filledData]="filledData" [isAdd]="isAdd" (valueChange)='catchFile($event)'
            (stepperChange)="stepChanged($event)" (changeDetected)="onChangeDetected($event)"></app-step-three>
    </div>
    <div class="stepper positionStatic" *ngIf="isStepper == 4">
        <div class="progress">
            <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:60%" aria-valuenow="60"
                aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <!-- End -->
        <app-step-four [filledData]="filledData" [isAdd]="isAdd" (valueChange)='catchFile($event)'
            (stepperChange)="stepChanged($event)" (changeDetected)="onChangeDetected($event)"></app-step-four>
    </div>
    <div class="stepper positionStatic" *ngIf="isStepper == 5">
        <div class="progress">
            <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:90%" aria-valuenow="90"
                aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <!-- End -->
        <app-step-five [filledData]="filledData" [isAdd]="isAdd" (valueChange)='catchFile($event)'
            (stepperChange)="stepChanged($event)" (changeDetected)="onChangeDetected($event)"></app-step-five>
    </div>
    <div class="stepper positionStatic" *ngIf="isStepper == 6">
        <div class="progress">
            <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:100%"
                aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <!-- End -->
        <app-preview [filledData]="filledData" [isAdd]="isAdd" (valueChange)='catchFile($event)'
            (stepperChange)="stepChanged($event)" (changeDetected)="onChangeDetected($event)"></app-preview>
    </div>

</div>